import { render } from "./GameActions.vue?vue&type=template&id=6c264f51&scoped=true"
import script from "./GameActions.vue?vue&type=script&lang=js"
export * from "./GameActions.vue?vue&type=script&lang=js"

import "./GameActions.vue?vue&type=style&index=0&id=6c264f51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c264f51"]])

export default __exports__